import { render, staticRenderFns } from "./Gallery-Slider-Module.vue?vue&type=template&id=3d61d0ee&"
import script from "./Gallery-Slider-Module.vue?vue&type=script&lang=js&"
export * from "./Gallery-Slider-Module.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports